/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as AuthRouteImport } from "./routes/_auth"
import { Route as SigninRouteImport } from "./routes/signin"
import { Route as AuthAgentsRouteImport } from "./routes/_auth/_agents"
import { Route as AuthAdminRouteImport } from "./routes/_auth/admin"
import { Route as AuthAgentConnectRouteImport } from "./routes/_auth/agent-connect"
import { Route as AuthSlackLinkRouteImport } from "./routes/_auth/slack-link"
import { Route as InterviewSlugRouteImport } from "./routes/interview.$slug"
import { Route as InviteTokenRouteImport } from "./routes/invite.$token"
import { Route as AuthAgentsIndexRouteImport } from "./routes/_auth/_agents/index"
import { Route as AuthAgentsBriefingsRouteImport } from "./routes/_auth/_agents/briefings"
import { Route as AuthAgentsChatsRouteImport } from "./routes/_auth/_agents/chats"
import { Route as AuthAgentsSearchRouteImport } from "./routes/_auth/_agents/search"
import { Route as AuthAgentsSettingsRouteImport } from "./routes/_auth/_agents/settings"
import { Route as AuthAdminIndexRouteImport } from "./routes/_auth/admin/index"
import { Route as AuthSetupWorkspaceRouteImport } from "./routes/_auth/setup/workspace"
import { Route as InterviewSessionTokenRouteImport } from "./routes/interview.session.$token"
import { Route as AuthAgentsBriefingsIndexRouteImport } from "./routes/_auth/_agents/briefings.index"
import { Route as AuthAgentsChatsIndexRouteImport } from "./routes/_auth/_agents/chats.index"
import { Route as AuthAgentsChatsConversationIdRouteImport } from "./routes/_auth/_agents/chats.$conversationId"
import { Route as AuthAgentsSettingsIndexRouteImport } from "./routes/_auth/_agents/settings.index"
import { Route as AuthAgentsSettingsConnectorsRouteImport } from "./routes/_auth/_agents/settings.connectors"
import { Route as AuthAgentsSettingsMemoryRouteImport } from "./routes/_auth/_agents/settings.memory"
import { Route as AuthAgentsSettingsProfileRouteImport } from "./routes/_auth/_agents/settings.profile"
import { Route as AuthAgentsSettingsSkillsRouteImport } from "./routes/_auth/_agents/settings.skills"
import { Route as AuthAgentsSettingsWorkspaceRouteImport } from "./routes/_auth/_agents/settings.workspace"
import { Route as AuthAgentsSourcingIndexRouteImport } from "./routes/_auth/_agents/sourcing.index"
import { Route as AuthAgentsSourcingListIdRouteImport } from "./routes/_auth/_agents/sourcing.$listId"
import { Route as AuthAgentsStudiesIndexRouteImport } from "./routes/_auth/_agents/studies.index"
import { Route as AuthAgentsStudiesNewRouteImport } from "./routes/_auth/_agents/studies.new"
import { Route as AuthAdminStudiesIndexRouteImport } from "./routes/_auth/admin/studies.index"
import { Route as AuthAdminStudiesNewRouteImport } from "./routes/_auth/admin/studies.new"
import { Route as AuthAdminWorkspacesIndexRouteImport } from "./routes/_auth/admin/workspaces.index"
import { Route as AuthAdminWorkspacesOrgIdRouteImport } from "./routes/_auth/admin/workspaces.$orgId"
import { Route as AuthAgentsStudiesIdIndexRouteImport } from "./routes/_auth/_agents/studies.$id.index"
import { Route as AuthAdminStudiesIdIndexRouteImport } from "./routes/_auth/admin/studies.$id.index"

const AuthRoute = AuthRouteImport.update({
  id: "/_auth",
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: "/signin",
  path: "/signin",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAgentsRoute = AuthAgentsRouteImport.update({
  id: "/_agents",
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => AuthRoute,
} as any)
const AuthAgentConnectRoute = AuthAgentConnectRouteImport.update({
  id: "/agent-connect",
  path: "/agent-connect",
  getParentRoute: () => AuthRoute,
} as any)
const AuthSlackLinkRoute = AuthSlackLinkRouteImport.update({
  id: "/slack-link",
  path: "/slack-link",
  getParentRoute: () => AuthRoute,
} as any)
const InterviewSlugRoute = InterviewSlugRouteImport.update({
  id: "/interview/$slug",
  path: "/interview/$slug",
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: "/invite/$token",
  path: "/invite/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAgentsIndexRoute = AuthAgentsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthAgentsRoute,
} as any)
const AuthAgentsBriefingsRoute = AuthAgentsBriefingsRouteImport.update({
  id: "/briefings",
  path: "/briefings",
  getParentRoute: () => AuthAgentsRoute,
} as any)
const AuthAgentsChatsRoute = AuthAgentsChatsRouteImport.update({
  id: "/chats",
  path: "/chats",
  getParentRoute: () => AuthAgentsRoute,
} as any)
const AuthAgentsSearchRoute = AuthAgentsSearchRouteImport.update({
  id: "/search",
  path: "/search",
  getParentRoute: () => AuthAgentsRoute,
} as any)
const AuthAgentsSettingsRoute = AuthAgentsSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AuthAgentsRoute,
} as any)
const AuthAdminIndexRoute = AuthAdminIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthSetupWorkspaceRoute = AuthSetupWorkspaceRouteImport.update({
  id: "/setup/workspace",
  path: "/setup/workspace",
  getParentRoute: () => AuthRoute,
} as any)
const InterviewSessionTokenRoute = InterviewSessionTokenRouteImport.update({
  id: "/interview/session/$token",
  path: "/interview/session/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAgentsBriefingsIndexRoute =
  AuthAgentsBriefingsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthAgentsBriefingsRoute,
  } as any)
const AuthAgentsChatsIndexRoute = AuthAgentsChatsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthAgentsChatsRoute,
} as any)
const AuthAgentsChatsConversationIdRoute =
  AuthAgentsChatsConversationIdRouteImport.update({
    id: "/$conversationId",
    path: "/$conversationId",
    getParentRoute: () => AuthAgentsChatsRoute,
  } as any)
const AuthAgentsSettingsIndexRoute = AuthAgentsSettingsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthAgentsSettingsRoute,
} as any)
const AuthAgentsSettingsConnectorsRoute =
  AuthAgentsSettingsConnectorsRouteImport.update({
    id: "/connectors",
    path: "/connectors",
    getParentRoute: () => AuthAgentsSettingsRoute,
  } as any)
const AuthAgentsSettingsMemoryRoute =
  AuthAgentsSettingsMemoryRouteImport.update({
    id: "/memory",
    path: "/memory",
    getParentRoute: () => AuthAgentsSettingsRoute,
  } as any)
const AuthAgentsSettingsProfileRoute =
  AuthAgentsSettingsProfileRouteImport.update({
    id: "/profile",
    path: "/profile",
    getParentRoute: () => AuthAgentsSettingsRoute,
  } as any)
const AuthAgentsSettingsSkillsRoute =
  AuthAgentsSettingsSkillsRouteImport.update({
    id: "/skills",
    path: "/skills",
    getParentRoute: () => AuthAgentsSettingsRoute,
  } as any)
const AuthAgentsSettingsWorkspaceRoute =
  AuthAgentsSettingsWorkspaceRouteImport.update({
    id: "/workspace",
    path: "/workspace",
    getParentRoute: () => AuthAgentsSettingsRoute,
  } as any)
const AuthAgentsSourcingIndexRoute = AuthAgentsSourcingIndexRouteImport.update({
  id: "/sourcing/",
  path: "/sourcing/",
  getParentRoute: () => AuthAgentsRoute,
} as any)
const AuthAgentsSourcingListIdRoute =
  AuthAgentsSourcingListIdRouteImport.update({
    id: "/sourcing/$listId",
    path: "/sourcing/$listId",
    getParentRoute: () => AuthAgentsRoute,
  } as any)
const AuthAgentsStudiesIndexRoute = AuthAgentsStudiesIndexRouteImport.update({
  id: "/studies/",
  path: "/studies/",
  getParentRoute: () => AuthAgentsRoute,
} as any)
const AuthAgentsStudiesNewRoute = AuthAgentsStudiesNewRouteImport.update({
  id: "/studies/new",
  path: "/studies/new",
  getParentRoute: () => AuthAgentsRoute,
} as any)
const AuthAdminStudiesIndexRoute = AuthAdminStudiesIndexRouteImport.update({
  id: "/studies/",
  path: "/studies/",
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminStudiesNewRoute = AuthAdminStudiesNewRouteImport.update({
  id: "/studies/new",
  path: "/studies/new",
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminWorkspacesIndexRoute =
  AuthAdminWorkspacesIndexRouteImport.update({
    id: "/workspaces/",
    path: "/workspaces/",
    getParentRoute: () => AuthAdminRoute,
  } as any)
const AuthAdminWorkspacesOrgIdRoute =
  AuthAdminWorkspacesOrgIdRouteImport.update({
    id: "/workspaces/$orgId",
    path: "/workspaces/$orgId",
    getParentRoute: () => AuthAdminRoute,
  } as any)
const AuthAgentsStudiesIdIndexRoute =
  AuthAgentsStudiesIdIndexRouteImport.update({
    id: "/studies/$id/",
    path: "/studies/$id/",
    getParentRoute: () => AuthAgentsRoute,
  } as any)
const AuthAdminStudiesIdIndexRoute = AuthAdminStudiesIdIndexRouteImport.update({
  id: "/studies/$id/",
  path: "/studies/$id/",
  getParentRoute: () => AuthAdminRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof AuthAgentsIndexRoute
  "/signin": typeof SigninRoute
  "/admin": typeof AuthAdminRouteWithChildren
  "/agent-connect": typeof AuthAgentConnectRoute
  "/slack-link": typeof AuthSlackLinkRoute
  "/interview/$slug": typeof InterviewSlugRoute
  "/invite/$token": typeof InviteTokenRoute
  "/briefings": typeof AuthAgentsBriefingsRouteWithChildren
  "/chats": typeof AuthAgentsChatsRouteWithChildren
  "/search": typeof AuthAgentsSearchRoute
  "/settings": typeof AuthAgentsSettingsRouteWithChildren
  "/setup/workspace": typeof AuthSetupWorkspaceRoute
  "/interview/session/$token": typeof InterviewSessionTokenRoute
  "/admin/": typeof AuthAdminIndexRoute
  "/chats/$conversationId": typeof AuthAgentsChatsConversationIdRoute
  "/settings/connectors": typeof AuthAgentsSettingsConnectorsRoute
  "/settings/memory": typeof AuthAgentsSettingsMemoryRoute
  "/settings/profile": typeof AuthAgentsSettingsProfileRoute
  "/settings/skills": typeof AuthAgentsSettingsSkillsRoute
  "/settings/workspace": typeof AuthAgentsSettingsWorkspaceRoute
  "/sourcing/$listId": typeof AuthAgentsSourcingListIdRoute
  "/studies/new": typeof AuthAgentsStudiesNewRoute
  "/admin/studies/new": typeof AuthAdminStudiesNewRoute
  "/admin/workspaces/$orgId": typeof AuthAdminWorkspacesOrgIdRoute
  "/briefings/": typeof AuthAgentsBriefingsIndexRoute
  "/chats/": typeof AuthAgentsChatsIndexRoute
  "/settings/": typeof AuthAgentsSettingsIndexRoute
  "/sourcing/": typeof AuthAgentsSourcingIndexRoute
  "/studies/": typeof AuthAgentsStudiesIndexRoute
  "/admin/studies/": typeof AuthAdminStudiesIndexRoute
  "/admin/workspaces/": typeof AuthAdminWorkspacesIndexRoute
  "/studies/$id/": typeof AuthAgentsStudiesIdIndexRoute
  "/admin/studies/$id/": typeof AuthAdminStudiesIdIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof AuthAgentsIndexRoute
  "/signin": typeof SigninRoute
  "/agent-connect": typeof AuthAgentConnectRoute
  "/slack-link": typeof AuthSlackLinkRoute
  "/interview/$slug": typeof InterviewSlugRoute
  "/invite/$token": typeof InviteTokenRoute
  "/search": typeof AuthAgentsSearchRoute
  "/setup/workspace": typeof AuthSetupWorkspaceRoute
  "/interview/session/$token": typeof InterviewSessionTokenRoute
  "/admin": typeof AuthAdminIndexRoute
  "/chats/$conversationId": typeof AuthAgentsChatsConversationIdRoute
  "/settings/connectors": typeof AuthAgentsSettingsConnectorsRoute
  "/settings/memory": typeof AuthAgentsSettingsMemoryRoute
  "/settings/profile": typeof AuthAgentsSettingsProfileRoute
  "/settings/skills": typeof AuthAgentsSettingsSkillsRoute
  "/settings/workspace": typeof AuthAgentsSettingsWorkspaceRoute
  "/sourcing/$listId": typeof AuthAgentsSourcingListIdRoute
  "/studies/new": typeof AuthAgentsStudiesNewRoute
  "/admin/studies/new": typeof AuthAdminStudiesNewRoute
  "/admin/workspaces/$orgId": typeof AuthAdminWorkspacesOrgIdRoute
  "/briefings": typeof AuthAgentsBriefingsIndexRoute
  "/chats": typeof AuthAgentsChatsIndexRoute
  "/settings": typeof AuthAgentsSettingsIndexRoute
  "/sourcing": typeof AuthAgentsSourcingIndexRoute
  "/studies": typeof AuthAgentsStudiesIndexRoute
  "/admin/studies": typeof AuthAdminStudiesIndexRoute
  "/admin/workspaces": typeof AuthAdminWorkspacesIndexRoute
  "/studies/$id": typeof AuthAgentsStudiesIdIndexRoute
  "/admin/studies/$id": typeof AuthAdminStudiesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_auth": typeof AuthRouteWithChildren
  "/signin": typeof SigninRoute
  "/_auth/_agents": typeof AuthAgentsRouteWithChildren
  "/_auth/admin": typeof AuthAdminRouteWithChildren
  "/_auth/agent-connect": typeof AuthAgentConnectRoute
  "/_auth/slack-link": typeof AuthSlackLinkRoute
  "/interview/$slug": typeof InterviewSlugRoute
  "/invite/$token": typeof InviteTokenRoute
  "/_auth/_agents/briefings": typeof AuthAgentsBriefingsRouteWithChildren
  "/_auth/_agents/chats": typeof AuthAgentsChatsRouteWithChildren
  "/_auth/_agents/search": typeof AuthAgentsSearchRoute
  "/_auth/_agents/settings": typeof AuthAgentsSettingsRouteWithChildren
  "/_auth/setup/workspace": typeof AuthSetupWorkspaceRoute
  "/interview/session/$token": typeof InterviewSessionTokenRoute
  "/_auth/_agents/": typeof AuthAgentsIndexRoute
  "/_auth/admin/": typeof AuthAdminIndexRoute
  "/_auth/_agents/chats/$conversationId": typeof AuthAgentsChatsConversationIdRoute
  "/_auth/_agents/settings/connectors": typeof AuthAgentsSettingsConnectorsRoute
  "/_auth/_agents/settings/memory": typeof AuthAgentsSettingsMemoryRoute
  "/_auth/_agents/settings/profile": typeof AuthAgentsSettingsProfileRoute
  "/_auth/_agents/settings/skills": typeof AuthAgentsSettingsSkillsRoute
  "/_auth/_agents/settings/workspace": typeof AuthAgentsSettingsWorkspaceRoute
  "/_auth/_agents/sourcing/$listId": typeof AuthAgentsSourcingListIdRoute
  "/_auth/_agents/studies/new": typeof AuthAgentsStudiesNewRoute
  "/_auth/admin/studies/new": typeof AuthAdminStudiesNewRoute
  "/_auth/admin/workspaces/$orgId": typeof AuthAdminWorkspacesOrgIdRoute
  "/_auth/_agents/briefings/": typeof AuthAgentsBriefingsIndexRoute
  "/_auth/_agents/chats/": typeof AuthAgentsChatsIndexRoute
  "/_auth/_agents/settings/": typeof AuthAgentsSettingsIndexRoute
  "/_auth/_agents/sourcing/": typeof AuthAgentsSourcingIndexRoute
  "/_auth/_agents/studies/": typeof AuthAgentsStudiesIndexRoute
  "/_auth/admin/studies/": typeof AuthAdminStudiesIndexRoute
  "/_auth/admin/workspaces/": typeof AuthAdminWorkspacesIndexRoute
  "/_auth/_agents/studies/$id/": typeof AuthAgentsStudiesIdIndexRoute
  "/_auth/admin/studies/$id/": typeof AuthAdminStudiesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/signin"
    | "/admin"
    | "/agent-connect"
    | "/slack-link"
    | "/interview/$slug"
    | "/invite/$token"
    | "/briefings"
    | "/chats"
    | "/search"
    | "/settings"
    | "/setup/workspace"
    | "/interview/session/$token"
    | "/admin/"
    | "/chats/$conversationId"
    | "/settings/connectors"
    | "/settings/memory"
    | "/settings/profile"
    | "/settings/skills"
    | "/settings/workspace"
    | "/sourcing/$listId"
    | "/studies/new"
    | "/admin/studies/new"
    | "/admin/workspaces/$orgId"
    | "/briefings/"
    | "/chats/"
    | "/settings/"
    | "/sourcing/"
    | "/studies/"
    | "/admin/studies/"
    | "/admin/workspaces/"
    | "/studies/$id/"
    | "/admin/studies/$id/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/signin"
    | "/agent-connect"
    | "/slack-link"
    | "/interview/$slug"
    | "/invite/$token"
    | "/search"
    | "/setup/workspace"
    | "/interview/session/$token"
    | "/admin"
    | "/chats/$conversationId"
    | "/settings/connectors"
    | "/settings/memory"
    | "/settings/profile"
    | "/settings/skills"
    | "/settings/workspace"
    | "/sourcing/$listId"
    | "/studies/new"
    | "/admin/studies/new"
    | "/admin/workspaces/$orgId"
    | "/briefings"
    | "/chats"
    | "/settings"
    | "/sourcing"
    | "/studies"
    | "/admin/studies"
    | "/admin/workspaces"
    | "/studies/$id"
    | "/admin/studies/$id"
  id:
    | "__root__"
    | "/_auth"
    | "/signin"
    | "/_auth/_agents"
    | "/_auth/admin"
    | "/_auth/agent-connect"
    | "/_auth/slack-link"
    | "/interview/$slug"
    | "/invite/$token"
    | "/_auth/_agents/briefings"
    | "/_auth/_agents/chats"
    | "/_auth/_agents/search"
    | "/_auth/_agents/settings"
    | "/_auth/setup/workspace"
    | "/interview/session/$token"
    | "/_auth/_agents/"
    | "/_auth/admin/"
    | "/_auth/_agents/chats/$conversationId"
    | "/_auth/_agents/settings/connectors"
    | "/_auth/_agents/settings/memory"
    | "/_auth/_agents/settings/profile"
    | "/_auth/_agents/settings/skills"
    | "/_auth/_agents/settings/workspace"
    | "/_auth/_agents/sourcing/$listId"
    | "/_auth/_agents/studies/new"
    | "/_auth/admin/studies/new"
    | "/_auth/admin/workspaces/$orgId"
    | "/_auth/_agents/briefings/"
    | "/_auth/_agents/chats/"
    | "/_auth/_agents/settings/"
    | "/_auth/_agents/sourcing/"
    | "/_auth/_agents/studies/"
    | "/_auth/admin/studies/"
    | "/_auth/admin/workspaces/"
    | "/_auth/_agents/studies/$id/"
    | "/_auth/admin/studies/$id/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  SigninRoute: typeof SigninRoute
  InterviewSlugRoute: typeof InterviewSlugRoute
  InviteTokenRoute: typeof InviteTokenRoute
  InterviewSessionTokenRoute: typeof InterviewSessionTokenRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_auth": {
      id: "/_auth"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/signin": {
      id: "/signin"
      path: "/signin"
      fullPath: "/signin"
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_auth/_agents": {
      id: "/_auth/_agents"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthAgentsRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/admin": {
      id: "/_auth/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/agent-connect": {
      id: "/_auth/agent-connect"
      path: "/agent-connect"
      fullPath: "/agent-connect"
      preLoaderRoute: typeof AuthAgentConnectRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/slack-link": {
      id: "/_auth/slack-link"
      path: "/slack-link"
      fullPath: "/slack-link"
      preLoaderRoute: typeof AuthSlackLinkRouteImport
      parentRoute: typeof AuthRoute
    }
    "/interview/$slug": {
      id: "/interview/$slug"
      path: "/interview/$slug"
      fullPath: "/interview/$slug"
      preLoaderRoute: typeof InterviewSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/invite/$token": {
      id: "/invite/$token"
      path: "/invite/$token"
      fullPath: "/invite/$token"
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_auth/_agents/": {
      id: "/_auth/_agents/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AuthAgentsIndexRouteImport
      parentRoute: typeof AuthAgentsRoute
    }
    "/_auth/_agents/briefings": {
      id: "/_auth/_agents/briefings"
      path: "/briefings"
      fullPath: "/briefings"
      preLoaderRoute: typeof AuthAgentsBriefingsRouteImport
      parentRoute: typeof AuthAgentsRoute
    }
    "/_auth/_agents/chats": {
      id: "/_auth/_agents/chats"
      path: "/chats"
      fullPath: "/chats"
      preLoaderRoute: typeof AuthAgentsChatsRouteImport
      parentRoute: typeof AuthAgentsRoute
    }
    "/_auth/_agents/search": {
      id: "/_auth/_agents/search"
      path: "/search"
      fullPath: "/search"
      preLoaderRoute: typeof AuthAgentsSearchRouteImport
      parentRoute: typeof AuthAgentsRoute
    }
    "/_auth/_agents/settings": {
      id: "/_auth/_agents/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof AuthAgentsSettingsRouteImport
      parentRoute: typeof AuthAgentsRoute
    }
    "/_auth/admin/": {
      id: "/_auth/admin/"
      path: "/"
      fullPath: "/admin/"
      preLoaderRoute: typeof AuthAdminIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/setup/workspace": {
      id: "/_auth/setup/workspace"
      path: "/setup/workspace"
      fullPath: "/setup/workspace"
      preLoaderRoute: typeof AuthSetupWorkspaceRouteImport
      parentRoute: typeof AuthRoute
    }
    "/interview/session/$token": {
      id: "/interview/session/$token"
      path: "/interview/session/$token"
      fullPath: "/interview/session/$token"
      preLoaderRoute: typeof InterviewSessionTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_auth/_agents/briefings/": {
      id: "/_auth/_agents/briefings/"
      path: "/"
      fullPath: "/briefings/"
      preLoaderRoute: typeof AuthAgentsBriefingsIndexRouteImport
      parentRoute: typeof AuthAgentsBriefingsRoute
    }
    "/_auth/_agents/chats/": {
      id: "/_auth/_agents/chats/"
      path: "/"
      fullPath: "/chats/"
      preLoaderRoute: typeof AuthAgentsChatsIndexRouteImport
      parentRoute: typeof AuthAgentsChatsRoute
    }
    "/_auth/_agents/chats/$conversationId": {
      id: "/_auth/_agents/chats/$conversationId"
      path: "/$conversationId"
      fullPath: "/chats/$conversationId"
      preLoaderRoute: typeof AuthAgentsChatsConversationIdRouteImport
      parentRoute: typeof AuthAgentsChatsRoute
    }
    "/_auth/_agents/settings/": {
      id: "/_auth/_agents/settings/"
      path: "/"
      fullPath: "/settings/"
      preLoaderRoute: typeof AuthAgentsSettingsIndexRouteImport
      parentRoute: typeof AuthAgentsSettingsRoute
    }
    "/_auth/_agents/settings/connectors": {
      id: "/_auth/_agents/settings/connectors"
      path: "/connectors"
      fullPath: "/settings/connectors"
      preLoaderRoute: typeof AuthAgentsSettingsConnectorsRouteImport
      parentRoute: typeof AuthAgentsSettingsRoute
    }
    "/_auth/_agents/settings/memory": {
      id: "/_auth/_agents/settings/memory"
      path: "/memory"
      fullPath: "/settings/memory"
      preLoaderRoute: typeof AuthAgentsSettingsMemoryRouteImport
      parentRoute: typeof AuthAgentsSettingsRoute
    }
    "/_auth/_agents/settings/profile": {
      id: "/_auth/_agents/settings/profile"
      path: "/profile"
      fullPath: "/settings/profile"
      preLoaderRoute: typeof AuthAgentsSettingsProfileRouteImport
      parentRoute: typeof AuthAgentsSettingsRoute
    }
    "/_auth/_agents/settings/skills": {
      id: "/_auth/_agents/settings/skills"
      path: "/skills"
      fullPath: "/settings/skills"
      preLoaderRoute: typeof AuthAgentsSettingsSkillsRouteImport
      parentRoute: typeof AuthAgentsSettingsRoute
    }
    "/_auth/_agents/settings/workspace": {
      id: "/_auth/_agents/settings/workspace"
      path: "/workspace"
      fullPath: "/settings/workspace"
      preLoaderRoute: typeof AuthAgentsSettingsWorkspaceRouteImport
      parentRoute: typeof AuthAgentsSettingsRoute
    }
    "/_auth/_agents/sourcing/": {
      id: "/_auth/_agents/sourcing/"
      path: "/sourcing"
      fullPath: "/sourcing/"
      preLoaderRoute: typeof AuthAgentsSourcingIndexRouteImport
      parentRoute: typeof AuthAgentsRoute
    }
    "/_auth/_agents/sourcing/$listId": {
      id: "/_auth/_agents/sourcing/$listId"
      path: "/sourcing/$listId"
      fullPath: "/sourcing/$listId"
      preLoaderRoute: typeof AuthAgentsSourcingListIdRouteImport
      parentRoute: typeof AuthAgentsRoute
    }
    "/_auth/_agents/studies/": {
      id: "/_auth/_agents/studies/"
      path: "/studies"
      fullPath: "/studies/"
      preLoaderRoute: typeof AuthAgentsStudiesIndexRouteImport
      parentRoute: typeof AuthAgentsRoute
    }
    "/_auth/_agents/studies/new": {
      id: "/_auth/_agents/studies/new"
      path: "/studies/new"
      fullPath: "/studies/new"
      preLoaderRoute: typeof AuthAgentsStudiesNewRouteImport
      parentRoute: typeof AuthAgentsRoute
    }
    "/_auth/admin/studies/": {
      id: "/_auth/admin/studies/"
      path: "/studies"
      fullPath: "/admin/studies/"
      preLoaderRoute: typeof AuthAdminStudiesIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/admin/studies/new": {
      id: "/_auth/admin/studies/new"
      path: "/studies/new"
      fullPath: "/admin/studies/new"
      preLoaderRoute: typeof AuthAdminStudiesNewRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/admin/workspaces/": {
      id: "/_auth/admin/workspaces/"
      path: "/workspaces"
      fullPath: "/admin/workspaces/"
      preLoaderRoute: typeof AuthAdminWorkspacesIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/admin/workspaces/$orgId": {
      id: "/_auth/admin/workspaces/$orgId"
      path: "/workspaces/$orgId"
      fullPath: "/admin/workspaces/$orgId"
      preLoaderRoute: typeof AuthAdminWorkspacesOrgIdRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/_agents/studies/$id/": {
      id: "/_auth/_agents/studies/$id/"
      path: "/studies/$id"
      fullPath: "/studies/$id/"
      preLoaderRoute: typeof AuthAgentsStudiesIdIndexRouteImport
      parentRoute: typeof AuthAgentsRoute
    }
    "/_auth/admin/studies/$id/": {
      id: "/_auth/admin/studies/$id/"
      path: "/studies/$id"
      fullPath: "/admin/studies/$id/"
      preLoaderRoute: typeof AuthAdminStudiesIdIndexRouteImport
      parentRoute: typeof AuthAdminRoute
    }
  }
}

interface AuthAgentsBriefingsRouteChildren {
  AuthAgentsBriefingsIndexRoute: typeof AuthAgentsBriefingsIndexRoute
}

const AuthAgentsBriefingsRouteChildren: AuthAgentsBriefingsRouteChildren = {
  AuthAgentsBriefingsIndexRoute: AuthAgentsBriefingsIndexRoute,
}

const AuthAgentsBriefingsRouteWithChildren =
  AuthAgentsBriefingsRoute._addFileChildren(AuthAgentsBriefingsRouteChildren)

interface AuthAgentsChatsRouteChildren {
  AuthAgentsChatsConversationIdRoute: typeof AuthAgentsChatsConversationIdRoute
  AuthAgentsChatsIndexRoute: typeof AuthAgentsChatsIndexRoute
}

const AuthAgentsChatsRouteChildren: AuthAgentsChatsRouteChildren = {
  AuthAgentsChatsConversationIdRoute: AuthAgentsChatsConversationIdRoute,
  AuthAgentsChatsIndexRoute: AuthAgentsChatsIndexRoute,
}

const AuthAgentsChatsRouteWithChildren = AuthAgentsChatsRoute._addFileChildren(
  AuthAgentsChatsRouteChildren,
)

interface AuthAgentsSettingsRouteChildren {
  AuthAgentsSettingsConnectorsRoute: typeof AuthAgentsSettingsConnectorsRoute
  AuthAgentsSettingsMemoryRoute: typeof AuthAgentsSettingsMemoryRoute
  AuthAgentsSettingsProfileRoute: typeof AuthAgentsSettingsProfileRoute
  AuthAgentsSettingsSkillsRoute: typeof AuthAgentsSettingsSkillsRoute
  AuthAgentsSettingsWorkspaceRoute: typeof AuthAgentsSettingsWorkspaceRoute
  AuthAgentsSettingsIndexRoute: typeof AuthAgentsSettingsIndexRoute
}

const AuthAgentsSettingsRouteChildren: AuthAgentsSettingsRouteChildren = {
  AuthAgentsSettingsConnectorsRoute: AuthAgentsSettingsConnectorsRoute,
  AuthAgentsSettingsMemoryRoute: AuthAgentsSettingsMemoryRoute,
  AuthAgentsSettingsProfileRoute: AuthAgentsSettingsProfileRoute,
  AuthAgentsSettingsSkillsRoute: AuthAgentsSettingsSkillsRoute,
  AuthAgentsSettingsWorkspaceRoute: AuthAgentsSettingsWorkspaceRoute,
  AuthAgentsSettingsIndexRoute: AuthAgentsSettingsIndexRoute,
}

const AuthAgentsSettingsRouteWithChildren =
  AuthAgentsSettingsRoute._addFileChildren(AuthAgentsSettingsRouteChildren)

interface AuthAgentsRouteChildren {
  AuthAgentsBriefingsRoute: typeof AuthAgentsBriefingsRouteWithChildren
  AuthAgentsChatsRoute: typeof AuthAgentsChatsRouteWithChildren
  AuthAgentsSearchRoute: typeof AuthAgentsSearchRoute
  AuthAgentsSettingsRoute: typeof AuthAgentsSettingsRouteWithChildren
  AuthAgentsIndexRoute: typeof AuthAgentsIndexRoute
  AuthAgentsSourcingListIdRoute: typeof AuthAgentsSourcingListIdRoute
  AuthAgentsStudiesNewRoute: typeof AuthAgentsStudiesNewRoute
  AuthAgentsSourcingIndexRoute: typeof AuthAgentsSourcingIndexRoute
  AuthAgentsStudiesIndexRoute: typeof AuthAgentsStudiesIndexRoute
  AuthAgentsStudiesIdIndexRoute: typeof AuthAgentsStudiesIdIndexRoute
}

const AuthAgentsRouteChildren: AuthAgentsRouteChildren = {
  AuthAgentsBriefingsRoute: AuthAgentsBriefingsRouteWithChildren,
  AuthAgentsChatsRoute: AuthAgentsChatsRouteWithChildren,
  AuthAgentsSearchRoute: AuthAgentsSearchRoute,
  AuthAgentsSettingsRoute: AuthAgentsSettingsRouteWithChildren,
  AuthAgentsIndexRoute: AuthAgentsIndexRoute,
  AuthAgentsSourcingListIdRoute: AuthAgentsSourcingListIdRoute,
  AuthAgentsStudiesNewRoute: AuthAgentsStudiesNewRoute,
  AuthAgentsSourcingIndexRoute: AuthAgentsSourcingIndexRoute,
  AuthAgentsStudiesIndexRoute: AuthAgentsStudiesIndexRoute,
  AuthAgentsStudiesIdIndexRoute: AuthAgentsStudiesIdIndexRoute,
}

const AuthAgentsRouteWithChildren = AuthAgentsRoute._addFileChildren(
  AuthAgentsRouteChildren,
)

interface AuthAdminRouteChildren {
  AuthAdminIndexRoute: typeof AuthAdminIndexRoute
  AuthAdminStudiesNewRoute: typeof AuthAdminStudiesNewRoute
  AuthAdminWorkspacesOrgIdRoute: typeof AuthAdminWorkspacesOrgIdRoute
  AuthAdminStudiesIndexRoute: typeof AuthAdminStudiesIndexRoute
  AuthAdminWorkspacesIndexRoute: typeof AuthAdminWorkspacesIndexRoute
  AuthAdminStudiesIdIndexRoute: typeof AuthAdminStudiesIdIndexRoute
}

const AuthAdminRouteChildren: AuthAdminRouteChildren = {
  AuthAdminIndexRoute: AuthAdminIndexRoute,
  AuthAdminStudiesNewRoute: AuthAdminStudiesNewRoute,
  AuthAdminWorkspacesOrgIdRoute: AuthAdminWorkspacesOrgIdRoute,
  AuthAdminStudiesIndexRoute: AuthAdminStudiesIndexRoute,
  AuthAdminWorkspacesIndexRoute: AuthAdminWorkspacesIndexRoute,
  AuthAdminStudiesIdIndexRoute: AuthAdminStudiesIdIndexRoute,
}

const AuthAdminRouteWithChildren = AuthAdminRoute._addFileChildren(
  AuthAdminRouteChildren,
)

interface AuthRouteChildren {
  AuthAgentsRoute: typeof AuthAgentsRouteWithChildren
  AuthAdminRoute: typeof AuthAdminRouteWithChildren
  AuthAgentConnectRoute: typeof AuthAgentConnectRoute
  AuthSlackLinkRoute: typeof AuthSlackLinkRoute
  AuthSetupWorkspaceRoute: typeof AuthSetupWorkspaceRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAgentsRoute: AuthAgentsRouteWithChildren,
  AuthAdminRoute: AuthAdminRouteWithChildren,
  AuthAgentConnectRoute: AuthAgentConnectRoute,
  AuthSlackLinkRoute: AuthSlackLinkRoute,
  AuthSetupWorkspaceRoute: AuthSetupWorkspaceRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  SigninRoute: SigninRoute,
  InterviewSlugRoute: InterviewSlugRoute,
  InviteTokenRoute: InviteTokenRoute,
  InterviewSessionTokenRoute: InterviewSessionTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
